export default "__VITE_ASSET__7344d212__"